import React, { useState } from 'react';
import { useDraft } from '../../hooks/useDraft';
import { keepInView } from './dom';

const stop = e => e.stopPropagation();

/**
 * Optional free-text amount ("2 crates", "5 lb", "1 sleeve") — a pill when set, a faint
 * "＋ Qty" when empty; tap to type. Saves on blur / Enter only (Esc cancels), so a
 * half-typed value is never stored. Its own tap zone (stops propagation), so it never
 * triggers a touch row's tap-to-complete or swipe.
 *
 * `cls` = the block class of the row it sits in ('do-item' on the Today board,
 * 'do-check' on the checklists) → `${cls}__qty`, `${cls}__qtyedit`.
 */
export function QtyPill({ value, onCommit, cls, addLabel, ariaLabel, placeholder, title, editAria }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useDraft(value, editing);
  const commit = () => {
    const v = draft.trim();
    setEditing(false);
    if (v !== (value || '')) onCommit(v);
  };
  if (editing) {
    return (
      <input className={`${cls}__qtyedit`} value={draft} autoFocus placeholder={placeholder} aria-label={editAria || ariaLabel}
        onFocus={keepInView} onClick={stop} onTouchStart={stop} onChange={e => setDraft(e.target.value)} onBlur={commit}
        onKeyDown={e => {
          stop(e);
          if (e.key === 'Enter') { e.preventDefault(); commit(); }
          if (e.key === 'Escape') { setDraft(value || ''); setEditing(false); }
        }} />
    );
  }
  return (
    <button type="button" className={`${cls}__qty ${cls}__qty--${value ? 'set' : 'empty'}`}
      onClick={e => { stop(e); setEditing(true); }} onTouchStart={stop} title={title} aria-label={ariaLabel}>
      {value || addLabel}
    </button>
  );
}
